import { Box, Chip, Typography } from '@mui/material';
import { CustomDatePicker } from '@components/CustomDatePicker';
import { DatePreset, datePresetFns } from '@utils/dates';

export const DatePickerWithChips = ({
    disabled = false,
    dateRange,
    onDateChange,
    datePreset,
    onDatePresetChange,
}: {
    disabled?: boolean;
    dateRange: { startDate?: string; endDate?: string };
    onDateChange: (range: { startDate?: string; endDate?: string }) => void;
    datePreset: DatePreset | null;
    onDatePresetChange: (preset: DatePreset | null) => void;
}) => {
    return (
        <Box display='flex' alignItems='center' gap='10px' flexWrap='wrap'>
            <Box display='flex' gap='10px' minWidth='300px' alignItems='center'>
                <Typography fontWeight='bold'>Select date range:</Typography>

                <CustomDatePicker
                    greyed={datePreset === DatePreset.AllTime}
                    disabled={disabled}
                    dateRange={dateRange as any}
                    setDateRange={(args) => {
                        onDatePresetChange(null);
                        onDateChange(args);
                    }}
                />
            </Box>

            <Box display='flex' gap='10px' minWidth='300px' flexWrap='wrap' alignItems='center'>
                <Typography fontWeight='bold'>or filter by:</Typography>

                {(Object.values(DatePreset) satisfies DatePreset[]).map((presetLabel) => {
                    return (
                        <Chip
                            key={`date-range-filter-${presetLabel}`}
                            sx={{ cursor: 'pointer', boxSizing: 'border-box' }}
                            variant={datePreset === presetLabel ? 'filled' : 'outlined'}
                            label={presetLabel}
                            onClick={() => {
                                onDatePresetChange(presetLabel);
                                onDateChange(datePresetFns[presetLabel]());
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
};
